var _rect, _g, _text, _rect2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _text2, _text3, _text4, _text5, _text6, _path, _circle, _circle2, _rect3, _rect4, _text7, _text8, _text9, _path2, _line8, _g2, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _g3, _text18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRitmoDosPassos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 705",
    fontFamily: "Inter, sans-serif",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1280,
    height: 705,
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#E2E4E9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 158,
    x2: 1030,
    y2: 158
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 202,
    x2: 1030,
    y2: 202
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 246,
    x2: 1030,
    y2: 246
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 290,
    x2: 1030,
    y2: 290
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 334,
    x2: 1030,
    y2: 334
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 440,
    x2: 1030,
    y2: 440
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 475,
    x2: 1030,
    y2: 475
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 510,
    x2: 1030,
    y2: 510
  }), /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 545,
    x2: 1030,
    y2: 545
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 28,
    fontSize: 20,
    fontWeight: 600,
    fill: "#0A0D14"
  }, "Ritmo dos Passos e Invers\xE3o de Sentido")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 198,
    width: 840,
    height: 88,
    fill: "#EEF4FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 198,
    x2: 1030,
    y2: 198,
    stroke: "#C8D8FD",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 286,
    x2: 1030,
    y2: 286,
    stroke: "#C8D8FD",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 242,
    x2: 1030,
    y2: 242,
    stroke: "#86909C",
    strokeWidth: 1,
    strokeDasharray: "5 4"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 288,
    y1: 110,
    x2: 288,
    y2: 545,
    stroke: "#39B719",
    strokeWidth: 1,
    strokeDasharray: "4 4"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 110,
    x2: 400,
    y2: 545,
    stroke: "#86909C",
    strokeWidth: 1,
    strokeDasharray: "4 4"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 498,
    y1: 110,
    x2: 498,
    y2: 545,
    stroke: "#39B719",
    strokeWidth: 1,
    strokeDasharray: "4 4"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 666,
    y1: 110,
    x2: 666,
    y2: 545,
    stroke: "#86909C",
    strokeWidth: 1,
    strokeDasharray: "4 4"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 288,
    y: 100,
    fontSize: 12,
    fontWeight: 600,
    fill: "#206014",
    textAnchor: "middle"
  }, "Imediato")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 498,
    y: 100,
    fontSize: 12,
    fontWeight: 600,
    fill: "#206014",
    textAnchor: "middle"
  }, "Imediato")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 666,
    y: 80,
    fontSize: 12,
    fontWeight: 600,
    fill: "#525866",
    textAnchor: "middle"
  }, "Atraso para Reduzir Est\xE1gio")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 80,
    fontSize: 12,
    fontWeight: 600,
    fill: "#525866",
    textAnchor: "middle"
  }, "Atraso para Adicionar Est\xE1gio")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 130,
    fontSize: 12,
    fontWeight: 600,
    fill: "#86909C"
  }, "Temperatura ambiente")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190,211 L232,202 L288,198 L340,185 L372,180 L400,189 L428,215 L470,259 L498,290 L540,299 L610,308 L700,312 L778,314 L890,316 L1030,317",
    fill: "none",
    stroke: "#F93A3A",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 288,
    cy: 198,
    r: 4.5,
    fill: "#39B719"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 498,
    cy: 290,
    r: 4.5,
    fill: "#39B719"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 356,
    width: 112,
    height: 16,
    fill: "#E2E4E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 498,
    y: 356,
    width: 168,
    height: 16,
    fill: "#E2E4E9"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 344,
    y: 352,
    fontSize: 12,
    fill: "#525866",
    textAnchor: "middle"
  }, "8 min")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 582,
    y: 352,
    fontSize: 12,
    fill: "#525866",
    textAnchor: "middle"
  }, "12 min")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 422,
    fontSize: 12,
    fontWeight: 600,
    fill: "#86909C"
  }, "Capacidade da m\xE1quina")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M190,510 H288 V475 H400 V440 H498 V475 H666 V510 H1030",
    fill: "none",
    stroke: "#363BC4",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 565,
    x2: 1030,
    y2: 565,
    stroke: "#E2E4E9",
    strokeWidth: 1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 158,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "26 \xB0C"), /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 202,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "25 \xB0C"), /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 246,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "24 \xB0C"), /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 290,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "23 \xB0C"), /*#__PURE__*/React.createElement("text", {
    x: 182,
    y: 334,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "end"
  }, "22 \xB0C"), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 565,
    x2: 260,
    y2: 571,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 565,
    x2: 400,
    y2: 571,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 565,
    x2: 540,
    y2: 571,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 565,
    x2: 680,
    y2: 571,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 565,
    x2: 820,
    y2: 571,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 960,
    y1: 565,
    x2: 960,
    y2: 571,
    stroke: "#86909C"
  }), /*#__PURE__*/React.createElement("text", {
    x: 260,
    y: 585,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "10:50"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 585,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "11:00"), /*#__PURE__*/React.createElement("text", {
    x: 540,
    y: 585,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "11:10"), /*#__PURE__*/React.createElement("text", {
    x: 680,
    y: 585,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "11:20"), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 585,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "11:30"), /*#__PURE__*/React.createElement("text", {
    x: 960,
    y: 585,
    fontSize: 12,
    fill: "#86909C",
    textAnchor: "middle"
  }, "11:40"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 202,
    fontSize: 12,
    fill: "#363BC4"
  }, "Setpoint + histerese superior")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 246,
    fontSize: 12,
    fill: "#525866"
  }, "Setpoint")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 290,
    fontSize: 12,
    fill: "#363BC4"
  }, "Setpoint \u2212 histerese inferior")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 364,
    fontSize: 12,
    fill: "#525866"
  }, "Atraso para adicionar/reduzir est\xE1gio")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 444,
    fontSize: 12,
    fill: "#525866"
  }, "Capacidade total")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 479,
    fontSize: 12,
    fill: "#525866"
  }, "Capacidade parcial")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 514,
    fontSize: 12,
    fill: "#525866"
  }, "Ventila\xE7\xE3o")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 1042,
    y: 549,
    fontSize: 12,
    fill: "#86909C"
  }, "Desligado")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 620,
    x2: 214,
    y2: 620,
    stroke: "#F93A3A",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 222,
    y: 624,
    fontSize: 12,
    fill: "#525866"
  }, "Temperatura ambiente"), /*#__PURE__*/React.createElement("path", {
    d: "M400,625 H406 V620 H412 V615 H418",
    fill: "none",
    stroke: "#363BC4",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 428,
    y: 624,
    fontSize: 12,
    fill: "#525866"
  }, "Capacidade da m\xE1quina"), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 614,
    width: 18,
    height: 12,
    fill: "#E2E4E9"
  }), /*#__PURE__*/React.createElement("text", {
    x: 646,
    y: 624,
    fontSize: 12,
    fill: "#525866"
  }, "Atraso para adicionar/reduzir est\xE1gio: espera para o pr\xF3ximo passo no mesmo sentido"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 190,
    y: 683,
    fontSize: 12,
    fill: "#86909C"
  }, "Setpoint 24 \xB0C \xB7 histereses 1 \xB0C \xB7 atraso para adicionar est\xE1gio 8 min \xB7 atraso para reduzir est\xE1gio 12 min")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRitmoDosPassos);
export default __webpack_public_path__ + "static/media/ritmo-dos-passos.44b599321162b6f48460517b2ecaa1c1.svg";
export { ForwardRef as ReactComponent };